// extracted by mini-css-extract-plugin
module.exports = {"text":"text-3zQ3cZD4","txtlist":"txtlist-13Kq0qiR","txt":"txt-29xGCMmB"};